







































import { Component, Vue, Watch, Prop } from "vue-property-decorator";
import { MyLessons, Lesson } from "@/types/MyLessons";
import LessonIcon from "./lessonIcon.vue";
import { Getter, Action } from "vuex-class";
import LessonDetail from "@/components/lessons/lessonDetail.vue";
import AssessmentBase from "@/components/assessment/assessmentBase.vue";
import bodymovin from "lottie-web";
import lessonloading from "@/assets/lottiefiles/lesson-loading.json";

@Component({
  components: {
    LessonIcon,
    LessonDetail,
    AssessmentBase,
  },
})
export default class UserLessons extends Vue {
  @Prop({ default: false }) private isEnterprise!: boolean;
  private activeTab: string = "library";
  private localDoneInitAssessment = false;
  @Getter private doneInitAssessment?: any;
  @Getter private currentLearnerTeamID?: string;
  @Getter private myLessons!: MyLessons;
  @Action private fetchMyLessons: any;
  @Action private setLearnerLessons!: any;
  @Getter private lessonByID!: (id: number) => Lesson;
  private selectedLesson: Lesson | null = null;

  private created() {
    this.setFocusLesson();
    this.localDoneInitAssessment = this.doneInitAssessment;
  }
  private lottieInit(el: Element, data: any) {
    bodymovin.loadAnimation({
      container: el,
      renderer: "svg",
      loop: true,
      animationData: data,
    });
    // console.log("lottied init");
  }
  private mounted() {
    let svgContainer = this.$refs.iframeloading as Element;
    this.lottieInit(svgContainer!, lessonloading);
  }

  private onDoneAssessment() {
    this.$emit("onDoneAssessment");
    this.localDoneInitAssessment = true;
  }

  @Watch("myLessons")
  private setFocusLesson() {
    let focusLessonID = this.$route.query.focusLessonID;
    if (!focusLessonID || this.selectedLesson) {
      return;
    }
    this.selectedLesson = this.lessonByID(Number(focusLessonID));
  }

  @Watch("currentLearnerTeamID", { immediate: true })
  private currentTeamChange() {
    const myLesson: MyLessons[] = [];
    this.setLearnerLessons(null);
    this.fetchMyLessons();
  }
}
